import type { FormValues, FormValuesEvents } from "@/widgets/classic-form/form";
import { locationDataModelToScope } from "@/features/place-exactness";
import type { SearchDataModel } from "@/entities/data-model";

export const mapDataModelToFormValues = (dataModel: SearchDataModel): FormValues => {
    const mappedEvents: FormValuesEvents = {};

    Object.entries(dataModel.events).forEach(([eventKey, event]) => {
        mappedEvents[eventKey] = {
            instances: event.instances.map((instance) => ({
                ...instance,
                locationExactness: locationDataModelToScope(instance.locationExactness),
            })),
            relation: event.relation,
            eventName: event.eventName,
        };
    });

    return {
        ...dataModel,
        recordSubject: dataModel.filters.recordSubject,
        events: mappedEvents,
    };
};
